export default __webpack_public_path__ + "static/media/cover-placeholder.7d647938.svg";